/**
 * SwitcherDivider.tsx — skillelinje i switcher
 *
 * Ren React-komponent som erstatter cds-switcher-divider.
 */

import styles from './switcher-divider.module.css';

export default function SwitcherDivider() {
  return <li className={styles.divider} aria-hidden="true" />;
}
